module.exports = __webpack_public_path__ + "img/des_jita_01.101cb3eb.jpg";